var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';
import { getLocalStorageValue, removeHtmlTags } from '../Utils/UtilityFunctions';
import { DEFAULT_DOCUMENT_GILROY_IAMGE, DEFAULT_GILROY_IMAGE, DEFAULT_GROUP_GILROY_IMAGE, SectionTypes } from '../Utils/Constants';
import { Base64 } from 'js-base64';
export var initialState = {
    conversationsLoading: false,
    converstationSections: [],
    deleteConversationLoading: false,
    deleteConversationLoaded: false,
    promptCategories: [],
    promptCustomCategories: [],
    promptCategoriesLoading: false,
    customCategoriesLoading: false,
    prompts: [],
    promptsLoading: false,
    selectedPromptCategory: {},
    showExamplePrompts: false,
    editConversationLoading: false,
    showLibrary: true,
    chatHistory: [],
    chatLoading: false,
    deleteChat: {},
    stopGeneratingIds: [],
    pendingChatId: 0,
    chatId: 1,
    chatHistoryLoading: false,
    selectedConversationId: -1,
    editChatLoading: false,
    peopleSection: {
        title: 'Matching People',
        type: SectionTypes.Executives,
        count: 0,
        linkedInCount: 0,
        persons: [],
        liveSearchPersons: [],
        followedPersons: [],
        firstCount: 0,
    },
    companiesSection: {
        title: 'Matching Companies',
        type: SectionTypes.Companies,
        count: 0,
        linkedInCount: 0,
        companies: [],
        followedCompanies: [],
        firstCount: 0,
    },
    buyerGroupsSection: {
        title: 'Buyer Groups',
        type: SectionTypes.BuyerGroups,
        groups: [],
        count: 0,
        firstCount: 0,
    },
    documentSection: {
        title: 'Matching Documents',
        type: SectionTypes.Documents,
        documents: [],
        count: 0,
        firstCount: 0,
    },
    searchResultspage: 0,
    isGlobalSearchLoading: false,
    isGlobalSearchLoaded: false,
    isPersonExtendedLoaded: false,
    isPersonExtendedLoading: false,
    personPage: 1,
    companyPage: 1,
    buyerPage: 1,
    documentPage: 1,
    query: '',
    taggedItem: null,
    showSearchPopup: false,
    isRegenerate: false,
    editInProgressId: 0,
    limitPopup: {},
    taggedItemsList: [],
    uniqueTagItemList: [],
    personCardLoading: false,
    idToReplace: null,
    scrollOnConvoUpdate: false,
    saveProfileName: '',
    saveUrl: '',
    generatingChannelId: 0,
    limitPopupVisible: false,
    tagSetupLoading: false,
    isNewChat: false,
    searchQuery: '',
    promptInProgress: '',
    placeholderToReplace: '',
    certificationPrompt: '',
    recentTags: [],
    historyPanelOpened: false,
    drawerPreviewOpen: false,
    history: [],
    showFavorite: false,
    favPromptAdded: false,
    favPromptRemoved: false,
    removedPromptId: 0,
    favPromptCount: 0,
    markFavoriteLoadingId: 0,
    categoryPermission: false,
    companyName: '',
    totalCustomCategories: 0,
    suggestedCategories: [],
    initialSuggestedCategories: [],
    unselectedPersonIds: [],
    totalPrompts: 0,
    editCategoryLoading: false,
    deleteCategoryLoading: false,
    addRemovePromptLoading: false,
    isNewCategoryOrPrompt: false,
    gilroyDataLoading: true,
    addRemovePromptLoaded: false,
    addRemovePromptError: '',
    isNewCategoryCreated: false,
    conversationFlag: false,
    regenResponseId: 0,
};
var ChatBotSliceV2 = createSlice({
    name: 'chatBotV2',
    initialState: initialState,
    reducers: {
        setShowLibrary: function (state, action) {
            state.showLibrary = action.payload;
        },
        getConversations: function (state, action) {
            state.conversationsLoading = true;
        },
        setConversations: function (state, action) {
            var _a, _b, _c;
            var newSections = action.payload.sections;
            var lastIndex = state.converstationSections.length - 1;
            if (action.payload.offset !== 0 && ((_a = state.converstationSections[lastIndex]) === null || _a === void 0 ? void 0 : _a.sectionName)
                === ((_b = newSections[0]) === null || _b === void 0 ? void 0 : _b.sectionName)) {
                var newData = (_c = newSections[0]) === null || _c === void 0 ? void 0 : _c.sectionData;
                var updatedData = state.converstationSections[lastIndex].sectionData.concat(newData);
                var sectionsWithoutFirstIndex = newSections.slice(1);
                state.converstationSections[lastIndex].sectionData = updatedData;
                state.converstationSections = __spreadArray(__spreadArray([], state.converstationSections, true), sectionsWithoutFirstIndex, true);
            }
            else {
                state.converstationSections = __spreadArray(__spreadArray([], state.converstationSections, true), newSections, true);
            }
            state.conversationsLoading = false;
        },
        deleteConversation: function (state, action) {
            state.deleteConversationLoading = true;
            state.deleteConversationLoaded = false;
        },
        setDeleteConversation: function (state, action) {
            var updatedSections = state.converstationSections.map(function (section) { return (__assign(__assign({}, section), { sectionData: section.sectionData.filter(function (conversation) { return conversation.channelId !== action.payload; }) })); })
                .filter(function (section) { return section.sectionData.length > 0; });
            state.converstationSections = updatedSections;
            state.deleteConversationLoading = false;
            state.deleteConversationLoaded = true;
        },
        setDeleteConversationLoaded: function (state, action) {
            state.deleteConversationLoaded = action.payload;
        },
        getPromptCategories: function (state, action) {
            if (action.payload.isCustomCategory) {
                state.customCategoriesLoading = true;
            }
            else {
                state.promptCategoriesLoading = true;
            }
        },
        setPromptCategories: function (state, action) {
            state.promptCategories = action.payload;
            state.promptCategoriesLoading = false;
        },
        setCustomPromptCategories: function (state, action) {
            var _a;
            state.promptCustomCategories = action.payload;
            state.totalCustomCategories = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.length;
            state.customCategoriesLoading = false;
            state.suggestedCategories = state.suggestedCategories.filter(function (category) { return !state.promptCustomCategories.some(function (promptCategory) { return promptCategory.title === category; }); });
        },
        getPrompts: function (state, action) {
            var _a;
            state.promptsLoading = true;
            if (!((_a = action.payload) === null || _a === void 0 ? void 0 : _a.offset)) {
                state.prompts = [];
                state.totalPrompts = 0;
                state.addRemovePromptError = '';
            }
        },
        setPrompts: function (state, action) {
            var _a = action.payload, offset = _a.offset, data = _a.data, totalPrompts = _a.totalPrompts;
            if (data === null || data === void 0 ? void 0 : data.length) {
                if (offset) {
                    state.prompts = __spreadArray(__spreadArray([], state.prompts, true), data, true);
                }
                else {
                    state.prompts = data;
                    state.totalPrompts = totalPrompts || 0;
                }
            }
            state.promptsLoading = false;
        },
        setSelectedPromptCategory: function (state, action) {
            state.selectedPromptCategory = action.payload;
            state.promptCustomCategories = state.promptCustomCategories.map(function (c) {
                var _a;
                if (c.categoryId === ((_a = action.payload) === null || _a === void 0 ? void 0 : _a.categoryId)) {
                    return __assign(__assign({}, c), { isNew: false });
                }
                return c;
            });
            var hasNewCategory = state.promptCustomCategories.some(function (category) { return category.isNew === true; });
            state.isNewCategoryOrPrompt = hasNewCategory;
        },
        editConversation: function (state, action) {
            state.editConversationLoading = true;
        },
        setEditConversation: function (state, action) {
            var _a = action.payload, text = _a.text, channelId = _a.channelId;
            var updatedSections = state.converstationSections.map(function (section) { return (__assign(__assign({}, section), { sectionData: section.sectionData.map(function (item) {
                    if (item.channelId === channelId) {
                        return __assign(__assign({}, item), { channelHeading: text });
                    }
                    return item;
                }) })); });
            state.converstationSections = updatedSections;
            state.editConversationLoading = false;
        },
        setShowExamplePrompts: function (state, action) {
            state.showExamplePrompts = action.payload;
            state.unselectedPersonIds = [];
            if (!action.payload && state.showFavorite) {
                state.showFavorite = false;
            }
        },
        chatbot: function (state, action) {
            var _a;
            state.chatLoading = true;
            state.showLibrary = false;
            state.pendingChatId = state.chatId;
            state.chatId += 1;
            state.promptInProgress = Base64.decode((_a = action.payload) === null || _a === void 0 ? void 0 : _a.prompt);
            state.regenResponseId = 0;
        },
        setChat: function (state, action) {
            var _a, _b, _c, _d, _e;
            var chatArray = action.payload.chat;
            var id = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.id;
            var channelId = (_b = action.payload) === null || _b === void 0 ? void 0 : _b.channelId;
            var channelHeading = (_c = action.payload) === null || _c === void 0 ? void 0 : _c.channelHeading;
            var isNewChat = (_d = action.payload) === null || _d === void 0 ? void 0 : _d.isNewChat;
            var source = (_e = action.payload) === null || _e === void 0 ? void 0 : _e.source;
            var sourceImg = '';
            switch (source) {
                case 'group':
                    sourceImg = DEFAULT_GROUP_GILROY_IMAGE;
                    break;
                case 'document':
                    sourceImg = DEFAULT_DOCUMENT_GILROY_IAMGE;
                    break;
                default:
                    sourceImg = DEFAULT_GILROY_IMAGE;
            }
            if (state.stopGeneratingIds.includes(id)) {
                state.deleteChat.chatId = chatArray[0].id;
                state.deleteChat.convoId = channelId || 0;
            }
            else {
                if (chatArray.length === 0) {
                    state.chatHistoryLoading = false;
                }
                chatArray.forEach(function (chat) {
                    var _a, _b, _c;
                    var chatObject = chat;
                    chatObject.chat = chatObject.chat.replace(/\n/g, '<br />');
                    var senderName = getLocalStorageValue('fullname');
                    chatObject.chat = chatObject.chat.replace(/\[Your Name\]/gi, senderName || '');
                    if (id) {
                        if (state.generatingChannelId === state.selectedConversationId) {
                            state.chatHistory = __spreadArray(__spreadArray([], state.chatHistory, true), [chatObject], false);
                        }
                        else {
                            state.chatLoading = false;
                        }
                        if (isNewChat) {
                            var channel = {
                                channelId: channelId || 0,
                                channelHeading: removeHtmlTags(channelHeading || ''),
                                isFavorite: false,
                                avatar: {
                                    image: ((_a = action.payload.image) === null || _a === void 0 ? void 0 : _a.length)
                                        ? action.payload.image : sourceImg,
                                    color: (_b = action.payload.color) !== null && _b !== void 0 ? _b : '',
                                },
                            };
                            if (((_c = state.converstationSections[0]) === null || _c === void 0 ? void 0 : _c.sectionName) === 'Today') {
                                state.converstationSections[0].sectionData = __spreadArray([channel], state.converstationSections[0].sectionData, true);
                            }
                            else {
                                var section = {
                                    sectionName: 'Today',
                                    sectionData: [channel],
                                };
                                state.converstationSections = __spreadArray([section], state.converstationSections, true);
                            }
                            if (state.generatingChannelId === state.selectedConversationId) {
                                state.selectedConversationId = channelId || 0;
                                state.generatingChannelId = channelId || 0;
                            }
                        }
                        state.chatLoading = false;
                    }
                    else {
                        state.chatHistory = __spreadArray([chatObject], state.chatHistory, true);
                        state.chatHistoryLoading = false;
                    }
                });
            }
        },
        setChatbotPopup: function (state, action) {
            state.limitPopup = action.payload;
            state.chatLoading = false;
        },
        setChatLoading: function (state, action) {
            state.chatLoading = action.payload;
        },
        setConversationFlag: function (state, action) {
            state.conversationFlag = action.payload;
        },
        getChatHistory: function (state, action) {
            state.chatHistoryLoading = true;
        },
        setSelectedConversationId: function (state, action) {
            state.selectedConversationId = action.payload;
        },
        sendFeedback: function (state, action) {
        },
        setFeedbackSubmitted: function (state, action) {
            var responseId = action.payload;
            state.chatHistory = state.chatHistory.map(function (chat) {
                if (chat.responseId === responseId) {
                    return __assign(__assign({}, chat), { feedbackSubmitted: true });
                }
                return chat;
            });
        },
        editChatResponse: function (state, action) {
            state.editChatLoading = true;
        },
        updateChatResponse: function (state, action) {
            var _a = action.payload, responseId = _a.responseId, chat = _a.chat;
            var chatIndex = state.chatHistory.findIndex(function (chatObject) { return chatObject.responseId === responseId; });
            var data = {
                chat: chat,
                edited: 1,
            };
            if (chatIndex !== -1) {
                var updatedChats = __spreadArray([], state.chatHistory, true);
                updatedChats[chatIndex] = __assign(__assign({}, updatedChats[chatIndex]), data);
                state.chatHistory = updatedChats;
            }
            state.editChatLoading = false;
        },
        setEditChatLoading: function (state, action) {
            state.editChatLoading = action.payload;
        },
        setStopGenerating: function (state, action) {
            state.stopGeneratingIds = __spreadArray(__spreadArray([], state.stopGeneratingIds, true), [action.payload], false);
            state.chatLoading = false;
        },
        deleteChat: function (state, action) {
        },
        setDeleteChat: function (state, action) {
            state.chatHistory = state.chatHistory.filter(function (chat) { return chat.id.toString() !== action.payload; });
        },
        setIsRegenerate: function (state, action) {
            state.isRegenerate = action.payload;
        },
        setEditInProgressId: function (state, action) {
            state.editInProgressId = action.payload;
        },
        setConvoToLatest: function (state, action) {
            var _a, _b;
            var channelIdToMove = action.payload;
            if (!(((_a = state.converstationSections[0]) === null || _a === void 0 ? void 0 : _a.sectionName) === 'Today' && channelIdToMove === ((_b = state.converstationSections[0]) === null || _b === void 0 ? void 0 : _b.sectionData[0].channelId))) {
                var conversationToMove_1;
                var sectionIndex_1;
                state.converstationSections.forEach(function (section, index) {
                    var conversation = section.sectionData.find(function (conv) { return conv.channelId === channelIdToMove; });
                    if (conversation) {
                        conversationToMove_1 = conversation;
                        sectionIndex_1 = index;
                    }
                });
                if (conversationToMove_1) {
                    if (state.converstationSections[0].sectionName === 'Today') {
                        if (sectionIndex_1 !== undefined) {
                            state.converstationSections[sectionIndex_1].sectionData = state.converstationSections[sectionIndex_1].sectionData.filter(function (conv) { return conv.channelId !== channelIdToMove; });
                        }
                        state.converstationSections[0].sectionData.unshift(conversationToMove_1);
                    }
                    else {
                        if (sectionIndex_1 !== undefined) {
                            state.converstationSections[sectionIndex_1].sectionData = state.converstationSections[sectionIndex_1].sectionData.filter(function (conv) { return conv.channelId !== channelIdToMove; });
                        }
                        var newSection = {
                            sectionName: 'Today',
                            sectionData: [conversationToMove_1],
                        };
                        state.converstationSections.unshift(newSection);
                    }
                }
                state.scrollOnConvoUpdate = true;
            }
        },
        setScrollOnConvoUpdate: function (state, action) {
            state.scrollOnConvoUpdate = action.payload;
        },
        setSaveProfileName: function (state, action) {
            state.saveProfileName = action.payload;
        },
        setSaveUrl: function (state, action) {
            state.saveUrl = action.payload;
        },
        setGeneratingChannelId: function (state, action) {
            state.generatingChannelId = action.payload;
        },
        resetChatHistory: function (state) {
            state.chatHistory = [];
        },
        personLinkedinSearch: function (state, action) {
            var _a, _b;
            var payload = action.payload;
            state.isPersonExtendedLoaded = true;
            state.isPersonExtendedLoading = false;
            state.peopleSection.liveSearchPersons = __spreadArray(__spreadArray([], ((_a = state.peopleSection.liveSearchPersons) !== null && _a !== void 0 ? _a : []), true), payload.results, true);
            state.peopleSection.linkedInCount = (_b = payload.count) !== null && _b !== void 0 ? _b : 0;
            if (state.peopleSection.linkedInCount > 0
                && state.searchResultspage === 1) {
                state.peopleSection.count += state.peopleSection.linkedInCount;
                state.peopleSection.firstCount = state.peopleSection.persons
                    ? state.peopleSection.persons.length : 0;
            }
        },
        globalSearchResultsLoaded: function (state, action) {
            var _a, _b, _c, _d;
            state.isGlobalSearchLoading = false;
            state.isGlobalSearchLoaded = true;
            (_a = action.payload) === null || _a === void 0 ? void 0 : _a.filter(function (section) { return section.type === SectionTypes.BuyerGroups; }).forEach(function (section) {
                var _a, _b, _c;
                state.buyerGroupsSection.title = section.title;
                state.buyerGroupsSection.groups = __spreadArray(__spreadArray([], (_b = (_a = state === null || state === void 0 ? void 0 : state.buyerGroupsSection) === null || _a === void 0 ? void 0 : _a.groups) !== null && _b !== void 0 ? _b : [], true), (_c = section.groups) !== null && _c !== void 0 ? _c : [], true);
                if (section.count > 0 && state.searchResultspage === 1) {
                    state.buyerGroupsSection.count += section.count;
                    state.buyerGroupsSection.firstCount = state.buyerGroupsSection.groups
                        ? state.buyerGroupsSection.groups.length : 0;
                }
            });
            (_b = action.payload) === null || _b === void 0 ? void 0 : _b.filter(function (section) { return section.type === SectionTypes.Companies; }).forEach(function (section) {
                var _a, _b, _c;
                state.companiesSection.title = section.title;
                state.companiesSection.companies = __spreadArray(__spreadArray([], (_b = (_a = state === null || state === void 0 ? void 0 : state.companiesSection) === null || _a === void 0 ? void 0 : _a.companies) !== null && _b !== void 0 ? _b : [], true), (_c = section.companies) !== null && _c !== void 0 ? _c : [], true);
                if (section.count > 0 && state.searchResultspage === 1) {
                    state.companiesSection.count += section.count;
                    state.companiesSection.firstCount = state.companiesSection.companies
                        ? state.companiesSection.companies.length : 0;
                }
            });
            (_c = action.payload) === null || _c === void 0 ? void 0 : _c.filter(function (section) { return section.type === SectionTypes.Executives; }).forEach(function (section) {
                var _a, _b;
                state.peopleSection.title = section.title;
                state.peopleSection.persons = __spreadArray(__spreadArray([], ((_a = state.peopleSection.persons) !== null && _a !== void 0 ? _a : []), true), ((_b = section.persons) !== null && _b !== void 0 ? _b : []), true);
                if (section.count > 0 && state.searchResultspage === 1) {
                    state.peopleSection.count += section.count;
                    state.peopleSection.firstCount = state.peopleSection.persons
                        ? state.peopleSection.persons.length : 0;
                }
            });
            (_d = action.payload) === null || _d === void 0 ? void 0 : _d.filter(function (section) { return section.type === SectionTypes.Documents; }).forEach(function (section) {
                var _a, _b;
                state.documentSection.title = section.title;
                state.documentSection.documents = __spreadArray(__spreadArray([], ((_a = state.documentSection.documents) !== null && _a !== void 0 ? _a : []), true), ((_b = section.documents) !== null && _b !== void 0 ? _b : []), true);
                if (section.count > 0 && state.searchResultspage === 1) {
                    state.documentSection.count += section.count;
                    state.documentSection.firstCount = state.documentSection.documents
                        ? state.documentSection.documents.length : 0;
                }
            });
        },
        globalSearchResultsError: function (state) {
            state.isGlobalSearchLoading = false;
            state.isGlobalSearchLoaded = true;
            state.isPersonExtendedLoaded = true;
            state.isPersonExtendedLoading = false;
        },
        globalSearchResults: function (state, action) {
            var _a;
            var _b = action.payload, page = _b.page, query = _b.query;
            state.searchQuery = query.trim();
            var temp = query.trim().split(':');
            if (temp[0].includes('group') || temp[0].includes('person') || temp[0].includes('company') || temp[0].includes('document')) {
                state.query = (_a = temp[1]) === null || _a === void 0 ? void 0 : _a.trim();
            }
            else {
                state.query = query.trim();
            }
            state.buyerPage = page && query.includes('group') ? page : state.buyerPage;
            state.personPage = page && query.includes('person') ? page : state.personPage;
            state.companyPage = page && query.includes('company') ? page : state.companyPage;
            state.documentPage = page && query.includes('document') ? page : state.documentPage;
            state.searchResultspage = page || 1;
            if (!page || page === 1) {
                state.isGlobalSearchLoaded = false;
                state.isPersonExtendedLoaded = false;
            }
            state.isGlobalSearchLoading = true;
            state.isPersonExtendedLoading = !query.includes('group') && !query.includes('company') && !query.includes('document');
            state.isPersonExtendedLoaded = query.includes('group') || query.includes('company') || query.includes('document') ? true : state.isPersonExtendedLoaded;
            state.peopleSection.persons = page
                ? state.peopleSection.persons
                : [];
            state.peopleSection.liveSearchPersons = page
                ? state.peopleSection.liveSearchPersons
                : [];
            state.peopleSection.count = page ? state.peopleSection.count : 0;
            state.companiesSection.companies = page
                ? state.companiesSection.companies
                : [];
            state.companiesSection.count = page
                ? state.companiesSection.count
                : 0;
            state.buyerGroupsSection.groups = page
                ? state.buyerGroupsSection.groups
                : [];
            state.buyerGroupsSection.count = page
                ? state.buyerGroupsSection.count
                : 0;
            state.companiesSection.count = page
                ? state.companiesSection.count
                : 0;
            state.documentSection.documents = page
                ? state.documentSection.documents
                : [];
            state.documentSection.count = page
                ? state.documentSection.count
                : 0;
        },
        setQuery: function (state, action) {
            state.query = action.payload;
        },
        setPeoplePage: function (state, action) {
            state.personPage = action.payload;
        },
        setCompaniesPage: function (state, action) {
            state.companyPage = action.payload;
        },
        setBuyerPage: function (state, action) {
            state.buyerPage = action.payload;
        },
        setDocumentsPage: function (state, action) {
            state.documentPage = action.payload;
        },
        setTaggedItem: function (state, action) {
            state.taggedItem = action.payload;
            if (action.payload) {
                state.taggedItemsList.push(action.payload);
            }
        },
        setUniqueTaggedItem: function (state, action) {
            var _a;
            if (action.payload) {
                var isIdExists = (_a = state.uniqueTagItemList) === null || _a === void 0 ? void 0 : _a.some(function (item) { return item.id === action.payload.id; });
                if (!isIdExists) {
                    state.uniqueTagItemList.push(action.payload);
                }
            }
        },
        removeUniqueTaggedItem: function (state, action) {
            var _a;
            if (action.payload) {
                state.uniqueTagItemList = (_a = state
                    .uniqueTagItemList) === null || _a === void 0 ? void 0 : _a.filter(function (item) { return item.id !== action.payload; });
            }
        },
        changeOrderRecentTags: function (state, action) {
            var _a;
            // Remove duplicates from action.payload based on 'id'
            var uniquePayload = action.payload.reduce(function (acc, current) {
                var existingIdSet = new Set(acc.map(function (obj) { return obj.id; }));
                if (!existingIdSet.has(current.id)) {
                    acc.push(current);
                }
                return acc;
            }, []);
            var payloadLength = uniquePayload.length;
            var idsToRemove = uniquePayload.map(function (obj) { return obj.id; });
            // Remove items with matching IDs from state.recentTags
            state.recentTags = state.recentTags.filter(function (obj) { return !idsToRemove.includes(obj.id); });
            var excessItems = state.recentTags.length + payloadLength - 10;
            // Trim excess items if needed
            if (excessItems > 0) {
                state.recentTags.splice(-excessItems);
            }
            // Add unique payload items to the beginning of state.recentTags
            (_a = state.recentTags).unshift.apply(_a, uniquePayload.reverse());
        },
        pushTagItem: function (state, action) {
            state.taggedItemsList.push(action.payload);
        },
        resetTagItemsList: function (state) {
            state.taggedItemsList = [];
            state.uniqueTagItemList = [];
        },
        tagLiveSearchPerson: function (state, action) {
            state.personCardLoading = true;
        },
        personSetup: function (state, action) {
            state.tagSetupLoading = true;
        },
        companySetup: function (state, action) {
            state.tagSetupLoading = true;
        },
        groupSetup: function (state, action) {
            state.tagSetupLoading = true;
        },
        removeTagItem: function (state, action) {
            var id = action.payload;
            var index = state.taggedItemsList.findIndex(function (item) { return item.id === id; });
            if (index !== -1) {
                state.taggedItemsList.splice(index, 1);
            }
        },
        recentTags: function (state, action) {
            var recentTags = action.payload.response.recentTags;
            state.recentTags = recentTags;
        },
        setLivePersonTag: function (state, action) {
            state.personCardLoading = false;
            var _a = action.payload, livesearchId = _a.livesearchId, executiveId = _a.executiveId, color = _a.color;
            var index = state.taggedItemsList.findIndex(function (item) { return item.id === livesearchId; });
            if (index !== -1 && executiveId) {
                state.taggedItemsList[index].id = executiveId;
                state.taggedItemsList[index].personType = 'EXECUTIVE';
                state.taggedItemsList[index].color = color;
                state.idToReplace = action.payload;
            }
            if (state.placeholderToReplace.includes(livesearchId.toString())) {
                state.placeholderToReplace = state.placeholderToReplace.replace(/ data-color="[^"]*"/g, '').replace(/ data-color=""/g, '').replace("id=\"".concat(livesearchId, "\""), "id=\"".concat(executiveId, "\" data-color=\"").concat(color, "\""));
            }
        },
        setPersonCardLoading: function (state, action) {
            state.personCardLoading = action.payload;
        },
        setTagSetupLoading: function (state, action) {
            state.tagSetupLoading = action.payload;
        },
        resetIdToReplacae: function (state) {
            state.idToReplace = null;
        },
        setSearchPopup: function (state, action) {
            state.searchQuery = '';
            state.showSearchPopup = action.payload;
            if (!action.payload) {
                state.searchResultspage = 0;
                state.isGlobalSearchLoading = false;
                state.isGlobalSearchLoaded = false;
                state.isPersonExtendedLoaded = false;
                state.isPersonExtendedLoading = false;
                state.personPage = 1;
                state.companyPage = 1;
                state.buyerPage = 1;
                state.documentPage = 1;
                state.query = '';
                state.buyerGroupsSection = initialState.buyerGroupsSection;
                state.peopleSection = initialState.peopleSection;
                state.companiesSection = initialState.companiesSection;
                state.documentSection = initialState.documentSection;
            }
        },
        resetChatbotPopup: function (state) {
            state.limitPopup.callToAction = '';
            state.limitPopup.contactUsEmail = '';
            state.limitPopup.popupText = '';
            state.limitPopup.showPlanPopup = 0;
        },
        resetTagging: function (state) {
            state.history = [];
            state.uniqueTagItemList = [];
            state.taggedItemsList = [];
            state.taggedItem = null;
            state.idToReplace = null;
            state.personCardLoading = false;
            state.peopleSection = {
                title: 'Matching People',
                type: SectionTypes.Executives,
                count: 0,
                linkedInCount: 0,
                persons: [],
                followedPersons: [],
                liveSearchPersons: [],
                firstCount: 0,
            };
            state.companiesSection = {
                title: 'Matching Companies',
                type: SectionTypes.Companies,
                count: 0,
                linkedInCount: 0,
                companies: [],
                followedCompanies: [],
                firstCount: 0,
            };
            state.buyerGroupsSection = {
                title: 'Buyer Groups',
                type: SectionTypes.BuyerGroups,
                groups: [],
                count: 0,
                firstCount: 0,
            };
            state.documentSection = {
                title: 'Matching Documents',
                type: SectionTypes.Documents,
                documents: [],
                count: 0,
                firstCount: 0,
            };
            state.searchResultspage = 0;
            state.isGlobalSearchLoading = false;
            state.isGlobalSearchLoaded = false;
            state.isPersonExtendedLoaded = false;
            state.isPersonExtendedLoading = false;
            state.personPage = 1;
            state.companyPage = 1;
            state.buyerPage = 1;
            state.documentPage = 1;
            state.query = '';
            state.limitPopupVisible = false;
        },
        setLimitPopupVisible: function (state, action) {
            state.limitPopupVisible = action.payload;
        },
        setIsNewChat: function (state, action) {
            state.isNewChat = action.payload;
        },
        setPromptInProgress: function (state, action) {
            state.promptInProgress = action.payload;
        },
        setPlaceholderToReplace: function (state, action) {
            state.placeholderToReplace = action.payload;
        },
        setCertificationPrompt: function (state, action) {
            state.certificationPrompt = action.payload;
        },
        setHistoryPanelOpened: function (state, action) {
            state.historyPanelOpened = action.payload;
        },
        getRecentTags: function (state) {
        },
        setDrawerPreviewOpen: function (state, action) {
            state.drawerPreviewOpen = action.payload;
        },
        setTagsList: function (state, action) {
            var _a = action.payload, allTags = _a.allTags, uniqueTags = _a.uniqueTags;
            state.taggedItemsList = allTags;
            state.uniqueTagItemList = uniqueTags;
        },
        setHistory: function (state, action) {
            state.history = action.payload;
        },
        setShowFavorite: function (state, action) {
            state.showFavorite = action.payload;
        },
        getFavoritePrompts: function (state, action) {
            var _a;
            state.promptsLoading = true;
            if (!((_a = action === null || action === void 0 ? void 0 : action.payload) === null || _a === void 0 ? void 0 : _a.offset)) {
                state.prompts = [];
            }
        },
        markFavoritePrompt: function (state, action) {
            var _a;
            var promptId = action.payload.promptId;
            if (promptId) {
                state.markFavoriteLoadingId = promptId;
            }
            state.removedPromptId = 0;
            if ((_a = action.payload) === null || _a === void 0 ? void 0 : _a.isFavourite) {
                state.favPromptAdded = false;
            }
            else {
                state.favPromptRemoved = false;
            }
        },
        setMarkFavoritePrompt: function (state, action) {
            var _a, _b, _c;
            var _d = action.payload, promptId = _d.promptId, isFavourite = _d.isFavourite, chatId = _d.chatId, prompt = _d.prompt, categories = _d.categories;
            if (chatId) {
                var index = state.chatHistory.findIndex(function (item) { return item.id === chatId; });
                if (index !== -1) {
                    state.chatHistory[index].isFavourite = isFavourite;
                }
            }
            if (promptId && !isFavourite) {
                var index = (_a = state.prompts) === null || _a === void 0 ? void 0 : _a.findIndex(function (item) { return (item === null || item === void 0 ? void 0 : item.promptId) === promptId; });
                if (index !== -1 && state.showFavorite) {
                    (_b = state.prompts) === null || _b === void 0 ? void 0 : _b.splice(index, 1);
                }
            }
            else if (promptId && isFavourite) {
                var index = state.chatHistory.findIndex(function (item) { return item.id === chatId; });
                if (index !== -1) {
                    state.chatHistory[index].promptId = promptId;
                }
            }
            if ((_c = state.selectedPromptCategory) === null || _c === void 0 ? void 0 : _c.categoryId) {
                var index = state.prompts.findIndex(function (item) { return item.promptId === promptId; });
                if (index !== -1) {
                    state.prompts[index].isFavourite = isFavourite;
                }
            }
            if (isFavourite) {
                if (state.showFavorite) {
                    var newPrompt = {
                        promptId: promptId,
                        prompt: prompt,
                        categories: categories,
                        isFavourite: true,
                    };
                    state.prompts = __spreadArray([newPrompt], state.prompts, true);
                }
                state.favPromptCount += 1;
                state.favPromptAdded = true;
            }
            else {
                state.favPromptRemoved = true;
                state.removedPromptId = promptId;
                state.favPromptCount -= 1;
            }
            state.markFavoriteLoadingId = 0;
        },
        setFavPromptCount: function (state, action) {
            state.favPromptCount = action.payload;
        },
        setFavPromptAdded: function (state, action) {
            state.favPromptAdded = action.payload;
        },
        setFavPromptRemoved: function (state, action) {
            state.favPromptRemoved = action.payload;
        },
        getGilroyData: function (state) {
            state.gilroyDataLoading = true;
        },
        setGilroyData: function (state, action) {
            var _a = action.payload, totalFavouritesPrompt = _a.totalFavouritesPrompt, totalCustomCategories = _a.totalCustomCategories, companyName = _a.companyName, categoryPermission = _a.categoryPermission, suggestedCategories = _a.suggestedCategories, isNewCategoryOrPrompt = _a.isNewCategoryOrPrompt;
            state.favPromptCount = totalFavouritesPrompt;
            state.totalCustomCategories = totalCustomCategories;
            state.companyName = companyName;
            state.categoryPermission = categoryPermission;
            if (!state.initialSuggestedCategories.length) {
                state.suggestedCategories = suggestedCategories;
            }
            state.initialSuggestedCategories = suggestedCategories;
            state.isNewCategoryOrPrompt = isNewCategoryOrPrompt;
            state.gilroyDataLoading = false;
        },
        setSuggestedCategories: function (state, action) {
            state.suggestedCategories = action.payload;
        },
        addRemovePromptFromCategory: function (state, action) {
            state.addRemovePromptLoading = true;
            state.addRemovePromptLoaded = false;
            state.addRemovePromptError = '';
            state.isNewCategoryCreated = false;
        },
        setAddRemovePromptFromCategory: function (state, action) {
            var _a, _b, _c;
            var _d = action.payload, category = _d.category, prompt = _d.prompt, categoryIds = _d.categoryIds, createCategoryOnly = _d.createCategoryOnly;
            categoryIds === null || categoryIds === void 0 ? void 0 : categoryIds.forEach(function (c) {
                var _a;
                if (((_a = state.selectedPromptCategory) === null || _a === void 0 ? void 0 : _a.categoryId) === c) {
                    var idDoesNotExist = state.prompts.every(function (p) { return p.promptId !== (prompt === null || prompt === void 0 ? void 0 : prompt.promptId); });
                    if (idDoesNotExist) {
                        state.totalPrompts += 1;
                        state.prompts = __spreadArray([__assign(__assign({}, prompt), { isNew: true })], state.prompts, true);
                    }
                }
            });
            if (category) {
                state.promptCustomCategories.unshift(__assign(__assign({}, category), { isNew: true }));
                state.totalCustomCategories += 1;
                state.isNewCategoryOrPrompt = true;
                if (!createCategoryOnly) {
                    state.isNewCategoryCreated = true;
                }
                state.suggestedCategories = state.suggestedCategories.filter(function (sCategory) { return sCategory !== (category === null || category === void 0 ? void 0 : category.title); });
            }
            var promptIndex = state.prompts.findIndex(function (p) { return p.promptId === (prompt === null || prompt === void 0 ? void 0 : prompt.promptId); });
            if (promptIndex !== -1) {
                if ((categoryIds === null || categoryIds === void 0 ? void 0 : categoryIds.length) || state.showFavorite) {
                    state.prompts[promptIndex].categories = state.promptCustomCategories.filter(function (c) { return categoryIds.includes(c.categoryId || 0); });
                    if (!(categoryIds === null || categoryIds === void 0 ? void 0 : categoryIds.includes(((_a = state.selectedPromptCategory) === null || _a === void 0 ? void 0 : _a.categoryId) || 0))
                        && !state.showFavorite) {
                        state.totalPrompts -= 1;
                        state.prompts = state.prompts.filter(function (p) { return p.promptId !== (prompt === null || prompt === void 0 ? void 0 : prompt.promptId); });
                    }
                }
                else {
                    state.totalPrompts -= 1;
                    state.prompts = state.prompts.filter(function (p) { return p.promptId !== (prompt === null || prompt === void 0 ? void 0 : prompt.promptId); });
                }
            }
            var chatIndex = (_b = state.chatHistory) === null || _b === void 0 ? void 0 : _b.findIndex(function (c) { return c.promptId === (prompt === null || prompt === void 0 ? void 0 : prompt.promptId); });
            if ((_c = state.chatHistory) === null || _c === void 0 ? void 0 : _c.length) {
                if (!(categoryIds === null || categoryIds === void 0 ? void 0 : categoryIds.length)) {
                    state.chatHistory[chatIndex].categories = [];
                }
                else if (chatIndex !== -1 && (categoryIds === null || categoryIds === void 0 ? void 0 : categoryIds.length)) {
                    state.chatHistory[chatIndex].categories = state.promptCustomCategories.filter(function (c) { return categoryIds.includes(c.categoryId || 0); });
                }
            }
            if (category && chatIndex !== -1) {
                state.chatHistory[chatIndex].categories = __spreadArray(__spreadArray([], state.chatHistory[chatIndex].categories || [], true), [
                    category
                ], false);
            }
            if (category && state.showFavorite && promptIndex !== -1) {
                state.prompts[promptIndex].categories = __spreadArray([category], state.prompts[promptIndex].categories || [], true);
            }
            state.addRemovePromptLoading = false;
            state.addRemovePromptLoaded = true;
        },
        setNewPromptFromCategory: function (state, action) {
            var _a, _b;
            var _c = action.payload, category = _c.category, prompt = _c.prompt, categoryIds = _c.categoryIds, chatId = _c.chatId, createCategoryOnly = _c.createCategoryOnly;
            var chatIndex = (_a = state.chatHistory) === null || _a === void 0 ? void 0 : _a.findIndex(function (c) { return c.id === chatId; });
            if (chatIndex !== -1) {
                state.chatHistory[chatIndex].promptId = prompt === null || prompt === void 0 ? void 0 : prompt.promptId;
            }
            if (categoryIds === null || categoryIds === void 0 ? void 0 : categoryIds.length) {
                var categories = (_b = state.promptCustomCategories) === null || _b === void 0 ? void 0 : _b.filter(function (c) { return categoryIds === null || categoryIds === void 0 ? void 0 : categoryIds.includes(c.categoryId || 0); });
                state.chatHistory[chatIndex].categories = categories;
            }
            if (category) {
                state.promptCustomCategories.unshift(__assign(__assign({}, category), { isNew: true }));
                state.totalCustomCategories += 1;
                state.isNewCategoryOrPrompt = true;
                if (!createCategoryOnly) {
                    state.isNewCategoryCreated = true;
                }
                state.suggestedCategories = state.suggestedCategories.filter(function (sCategory) { return sCategory !== (category === null || category === void 0 ? void 0 : category.title); });
                if (chatIndex !== -1) {
                    state.chatHistory[chatIndex].categories = __spreadArray(__spreadArray([], state.chatHistory[chatIndex].categories || [], true), [
                        category
                    ], false);
                }
            }
            state.addRemovePromptLoading = false;
            state.addRemovePromptLoaded = true;
        },
        setAddRemovePromptError: function (state, action) {
            state.addRemovePromptError = action.payload;
        },
        editCustomCategory: function (state, action) {
            state.editCategoryLoading = true;
        },
        setEditCustomCategory: function (state, action) {
            var _a, _b, _c, _d, _e;
            var categoryId = action.payload.categoryId;
            var index = state.promptCustomCategories.findIndex(function (item) { return item.categoryId === categoryId; });
            if ((_a = state.initialSuggestedCategories) === null || _a === void 0 ? void 0 : _a.includes(action.payload.title)) {
                state.suggestedCategories = state.suggestedCategories.filter(function (sCategory) { return sCategory !== action.payload.title; });
            }
            if (index !== -1) {
                if ((_b = state.initialSuggestedCategories) === null || _b === void 0 ? void 0 : _b.includes((_c = state.promptCustomCategories[index]) === null || _c === void 0 ? void 0 : _c.title)) {
                    state.suggestedCategories.push((_d = state.promptCustomCategories[index]) === null || _d === void 0 ? void 0 : _d.title);
                }
                state.promptCustomCategories[index] = action.payload;
            }
            state.selectedPromptCategory = action.payload;
            state.prompts = (_e = state.prompts) === null || _e === void 0 ? void 0 : _e.map(function (prompt) {
                var _a;
                return (__assign(__assign({}, prompt), { categories: (_a = prompt.categories) === null || _a === void 0 ? void 0 : _a.map(function (category) { return (category.categoryId === categoryId
                        ? action.payload
                        : category); }) }));
            });
            state.editCategoryLoading = false;
            state.chatHistory = [];
        },
        deleteCustomCategory: function (state, action) {
            state.deleteCategoryLoading = true;
        },
        setDeleteCustomCategory: function (state, action) {
            var _a, _b, _c;
            var deletedCategory = (_a = state.promptCustomCategories) === null || _a === void 0 ? void 0 : _a.find(function (category) { return (category === null || category === void 0 ? void 0 : category.categoryId) === action.payload; });
            state.promptCustomCategories = (_b = state.promptCustomCategories) === null || _b === void 0 ? void 0 : _b.filter(function (c) { return c.categoryId !== action.payload; });
            state.selectedPromptCategory = {};
            state.showExamplePrompts = false;
            state.totalCustomCategories -= 1;
            state.deleteCategoryLoading = false;
            state.chatHistory = [];
            if ((_c = state.initialSuggestedCategories) === null || _c === void 0 ? void 0 : _c.includes((deletedCategory === null || deletedCategory === void 0 ? void 0 : deletedCategory.title) || '')) {
                state.suggestedCategories.push((deletedCategory === null || deletedCategory === void 0 ? void 0 : deletedCategory.title) || '');
            }
        },
        setUnselectedPersonIds: function (state, action) {
            state.unselectedPersonIds = action.payload;
        },
        setAddRemovePromptLoaded: function (state, action) {
            state.addRemovePromptLoaded = action.payload;
        },
        setIsNewCategoryCreated: function (state, action) {
            state.isNewCategoryCreated = action.payload;
        },
        setRegenResponseId: function (state, action) {
            state.regenResponseId = action.payload;
        },
        removeRecentTagOnDocDelete: function (state, action) {
            var _a;
            state.recentTags = (_a = state.recentTags) === null || _a === void 0 ? void 0 : _a.filter(function (tag) { var _a; return !(((_a = action.payload) === null || _a === void 0 ? void 0 : _a.includes(tag === null || tag === void 0 ? void 0 : tag.id)) && (tag === null || tag === void 0 ? void 0 : tag.type) === 'document'); });
        },
        setPromptsOrder: function (state, action) {
            state.prompts = action.payload;
        },
        reorderPrompts: function (state, action) {
        },
        editPrompt: function (state, action) {
        },
        setEditPrompt: function (state, action) {
            var _a;
            var _b = action.payload, promptId = _b.promptId, prompt = _b.prompt, updatedBy = _b.updatedBy, prevPromptId = _b.prevPromptId;
            state.prompts = (_a = state.prompts) === null || _a === void 0 ? void 0 : _a.map(function (iprompt) {
                if (iprompt.promptId === prevPromptId) {
                    return __assign(__assign({}, iprompt), { prompt: prompt, updatedBy: updatedBy, promptId: promptId });
                }
                return iprompt;
            });
        },
        resetPrompts: function (state) {
            state.prompts = [];
            state.totalPrompts = 0;
        },
        reset: function (state) { return (__assign(__assign({}, initialState), { promptCategories: state.promptCategories })); },
    },
});
export var actions = ChatBotSliceV2.actions, reducer = ChatBotSliceV2.reducer, sliceKey = ChatBotSliceV2.name;
